<div class="content">
  <div class="modal-header">
    <h4 class="modal-title full-width ">
      <h3 *ngIf="!paymentDone">{{'LABELS.SELECT_SAVED_CARD_FOR_PAYMENT' | translate}}</h3>
      <div *ngIf="paymentDone" class="alert alert-success">{{'LABELS.PAYMENT_COMPLETED_SUCCESSFULLY' | translate}}</div>
    </h4>
    <button type="button" class="close invoice-timeline-view-close-btn" aria-label="Close"
      (click)="activeModal?.dismiss(null)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col">
        <div>
          <div class="table-responsive" appSlimScroll style="height: 250px;" *ngIf="!paymentDone">
            <ng-container *ngIf="addedCardsForSeller.length">
              <table class="table table-sm table-hover m-0 text-nowrap nowrap table-sortable">
                <thead class="thead-light">
                  <tr>
                    <th>{{'LABELS.CARD_TYPE' | translate}}</th>
                    <th>{{'LABELS.CARDHOLDERS_NAME' | translate}}</th>
                    <th>{{'LABELS.CARDHOLDERS_NAME' | translate}}</th>
                    <th>{{'LABELS.EXPIRATION' | translate}}</th>
                    <th class="text-start">{{'LABELS.STATUS'|translate}}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let card of addedCardsForSeller">
                    <td class="text-start">
                      <i class="fab {{card.icon}}" style="font-size: 32px; color: black;"></i>
                    </td>
                    <td class="text-start">
                      {{card.name}}
                    </td>
                    <td class="text-start">
                      {{card.cardNo}}
                    </td>
                    <td class="text-start">
                      {{card.expMonth}} / {{card.expYear}}
                    </td>
                    <th class="text-start">
                      <span class="badge bg-success m-1">{{'LABELS.ACTIVE' | translate}}</span>
                    </th>
                    <th class="text-end">
                      <button type="button" class="btn  fis-btn btn-sm"
                        (click)="enterCvv(card)">{{'LABELS.SELECT' | translate}}</button>
                    </th>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </div>
          <div *ngIf="paymentClicked" class="col m-4">
            <label class="row">{{ 'LABELS.PLEASE_ENTER_YOUR_CVV' | translate}}</label>
            <input class="row mt-2 form-control" maxlength="4" type="number"/>
            <button type="button" class="btn mt-2  fis-btn row" (click)="selectCardForPayment()">{{'LABELS.PROCEED_TO_PAY' | translate}}</button>
          </div>
          <div *ngIf="paymentDone">
            <ng-container *ngIf="paymentResp">
              <table class="table table-sm table-bordered table-hover m-0 text-nowrap nowrap table-sortable">
                <tbody>
                  <tr *ngFor="let resp of paymentResp">
                    <td class="text-start">
                      {{resp.key}}
                    </td>
                    <td class="text-start">
                      {{resp.data}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
            <ng-container *ngIf="paymentErrorResp">
              {{paymentErrorResp | json }}
            </ng-container>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
  </div>
  <div class="card-disabled" *ngIf="loading">
    <div class="card-portlets-loader">
      <div class="spinner-border text-primary m-2" role="status"></div>
    </div>
  </div>
</div>
